import "./index.css";
import bigplus from "../../assets/shapes_svg/product/bigplus.svg";
import { useState } from "react";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import DeleteIcon from "@mui/icons-material/Delete";
import { ShortButton, RegularButton } from "../../components/Button";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import line from "../../assets/shapes_svg/sections/longline.svg";
import EditableResult from "../../components/EditableResult";
import { useTranslation } from "react-i18next";
import { DuplicateButton } from "../DuplicateButton";

export const EditableResultList = ({
  result,
  edit,
  setEdit,
  changeTo,
  setValue,
  indeks,
  property,
}) => {
  return (
    <>
      {!edit ? (
        <h4>{result}</h4>
      ) : (
        <input
          type="text"
          value={changeTo}
          onChange={(e) => setValue(e.target.value, indeks, property)}
          className="custom__input"
        />
      )}
      {!edit ? (
        <EditIcon
          style={{ marginLeft: 40, cursor: "pointer" }}
          onClick={() => setEdit(true, indeks, property)}
        />
      ) : (
        <>
          <CheckIcon
            style={{ marginLeft: 40, cursor: "pointer" }}
            onClick={() => setEdit(false, indeks, property)}
          />
          <CloseIcon
            style={{ marginLeft: 8, cursor: "pointer" }}
            onClick={() => setEdit(false, indeks, property)}
          />
        </>
      )}
    </>
  );
};

export const ModalProductDetail = ({ closeModal }) => {
  document.getElementsByTagName("body")[0].className = "modal-open";
  /*
    {
            "name" : "Nylon",
            "category" : "Tekstil",
            "quantity": 30,
            "new_figure" : "fire",
            "source" : "fire"
        }
    */
  const [name, setName] = useState("");
  const [components, setComponents] = useState([
    {
      name: "Nylon",
      category: "Tekstil",
      quantity: 30,
      new_figure: "fire",
      source: "fire",
    },
    {
      name: "PVC Backing",
      category: "PVC",
      quantity: 30,
      new_figure: "fire",
      source: "fire",
    },
  ]);

  const [editName, setEditName] = useState(false);
  const [editComponents, setEditComponents] = useState([
    {
      name: false,
      category: false,
      quantity: false,
      new_figure: false,
      source: false,
      expand: false,
    },
    {
      name: false,
      category: false,
      quantity: false,
      new_figure: false,
      source: false,
      expand: false,
    },
  ]);

  const { t } = useTranslation();

  const handleEditList = (value, index, property) => {
    setEditComponents(
      editComponents.map((editVehicle, i) => {
        if (i == index) {
          let obj = { ...editVehicle };
          obj[property] = value;
          return obj;
        }
        return editVehicle;
      })
    );
  };

  const handleResultList = (value, index, property) => {
    setComponents((prev) =>
      prev.map((vehicle, i) => {
        if (i == index) {
          let obj = { ...vehicle };
          obj[property] = value;
          return obj;
        }
        return vehicle;
      })
    );
  };

  const handleAddComponent = () => {
    setComponents([
      ...components,
      {
        name: "",
        category: "",
        quantity: 0,
        new_figure: "",
        source: "",
      },
    ]);
    setEditComponents([
      ...editComponents,
      {
        name: true,
        category: true,
        quantity: true,
        new_figure: true,
        source: true,
        expand: true,
      },
    ]);
  };
  return (
    <div className="modaladdproduct">
      <div className="modaladdproduct__modal">
        <div className="modaladdproduct__close" onClick={closeModal}>
          <CloseIcon style={{ fontSize: "34px" }} />
        </div>
        <h4>{t("PRODUCT_OR_SERVICE")}</h4>
        <div className="modaladdproduct__question">
          <h3>{t("NAME")} :</h3>
          <EditableResult
            result={"Carpet tiles"}
            edit={editName}
            setEdit={setEditName}
            changeTo={name}
            setValue={setName}
          />
        </div>
        <div className="modaladdproduct__info">
          <h4 style={{ marginTop: "15px" }}>{t("ADD_PRODUCT_INTRO")}</h4>
        </div>
        <div className="modaladdproduct__header">
          <h3>{t("COMPONENTS")}</h3>
          <RegularButton
            click={handleAddComponent}
            text={t("ADD_COMPONENTS")}
            style={2}
          />
        </div>
        {components && components.length >= 1
          ? components.map((component, i) => {
              return (
                <div className="modaladdproduct__groupoptionexpand">
                  <div className="modaladdproduct__groupoption__header">
                    {editComponents && editComponents[i].expand == false ? (
                      <ExpandMoreIcon
                        onClick={() => handleEditList(true, i, "expand")}
                      />
                    ) : (
                      <ExpandLessIcon
                        onClick={() => handleEditList(false, i, "expand")}
                      />
                    )}
                    <h4 style={{ marginLeft: "10px" }}>{component.name},</h4>
                    <h3>cat.</h3> <h4>{component.category},</h4>
                    <h3>qty.</h3> <h4>{component.quantity}</h4> <h3>tonnes.</h3>
                  </div>

                  {editComponents && editComponents[i].expand == true ? (
                    <div className="modaladdproduct__groupoption">
                      <div className="modaladdproduct__group">
                        <div className="modaladdproduct__question">
                          <h3>{t("NAME")} :</h3>
                          <EditableResultList
                            result={component.name}
                            edit={editComponents[i].name}
                            changeTo={components[i].name}
                            setValue={handleResultList}
                            indeks={i}
                            property={"name"}
                          />
                        </div>
                        <div className="modaladdproduct__question">
                          <h3>{t("CATEGORY")} :</h3>
                          <EditableResultList
                            result={component.category}
                            edit={editComponents[i].category}
                            changeTo={components[i].category}
                            setValue={handleResultList}
                            indeks={i}
                            property={"category"}
                          />
                          <h4>{t("TONNES")}</h4>
                        </div>
                        <div className="modaladdproduct__question">
                          <h3>{t("QUANTITY")} :</h3>
                          <EditableResultList
                            result={component.quantity}
                            edit={editComponents[i].quantity}
                            changeTo={components[i].quantity}
                            setValue={handleResultList}
                            indeks={i}
                            property={"quantity"}
                          />
                        </div>
                        <div className="modaladdproduct__question">
                          <h3>{t("NEW_FIGURE")} :</h3>
                          <EditableResultList
                            result={component.new_figure}
                            edit={editComponents[i].new_figure}
                            changeTo={components[i].new_figure}
                            setValue={handleResultList}
                            indeks={i}
                            property={"new_figure"}
                          />
                        </div>
                        <div className="modaladdproduct__question">
                          <h3>{t("SOURCE")} :</h3>
                          <EditableResultList
                            result={component.source}
                            edit={editComponents[i].source}
                            changeTo={components[i].source}
                            setValue={handleResultList}
                            indeks={i}
                            property={"source"}
                          />
                        </div>
                      </div>
                      <div className="modaladdproduct__question">
                        <h3>{t("ESTIMATED_CARBON")} :</h3>
                        <h4>{t("TONNES")}</h4>
                      </div>
                      <div className="modaladdproduct__option">
                        <ShortButton
                          text={<DeleteIcon style={{ fontSize: "28px" }} />}
                          style={2}
                        />
                      </div>
                    </div>
                  ) : null}
                  <img
                    style={
                      editComponents && editComponents[i].expand == false
                        ? { marginTop: "10px" }
                        : null
                    }
                    src={line}
                    alt=""
                  />
                </div>
              );
            })
          : null}
        {/* {
                    components && components.length >=1  ?
                    components.map((component,i) => {
                        return <div className="modaladdproduct__groupoption">
                            <div className="modaladdproduct__group">
                                    <div className="modaladdproduct__question">
                                        <h3>Name :</h3>
                                        <EditableResultList result={component.name}
                                            edit={editComponents[i].name}

                                            changeTo={components[i].name}
                                            setValue={handleResultList}
                                            indeks={i}
                                            property={"name"}
                                            />

                                    </div>
                                    <div className="modaladdproduct__question">
                                        <h3>Category :</h3>
                                        <EditableResultList result={component.category}
                                            edit={editComponents[i].category}

                                            changeTo={components[i].category}
                                            setValue={handleResultList}
                                            indeks={i}
                                            property={"category"}
                                            />
                                        <h4>tonnes</h4>
                                    </div>
                                    <div className="modaladdproduct__question">
                                        <h3>Quantity :</h3>
                                        <EditableResultList result={component.quantity}
                                            edit={editComponents[i].quantity}

                                            changeTo={components[i].quantity}
                                            setValue={handleResultList}
                                            indeks={i}
                                            property={"quantity"}
                                            />
                                    </div>
                                    <div className="modaladdproduct__question">
                                        <h3>Estimated embodied carbon :</h3>
                                        <h4>tonnes</h4>
                                    </div>
                                    <div className="modaladdproduct__question">
                                        <h3>New figure :</h3>
                                        <EditableResultList result={component.new_figure}
                                            edit={editComponents[i].new_figure}

                                            changeTo={components[i].new_figure}
                                            setValue={handleResultList}
                                            indeks={i}
                                            property={"new_figure"}
                                            />
                                    </div>
                                    <div className="modaladdproduct__question">
                                        <h3>Source :</h3>
                                        <EditableResultList result={component.source}
                                            edit={editComponents[i].source}

                                            changeTo={components[i].source}
                                            setValue={handleResultList}
                                            indeks={i}
                                            property={"source"}
                                            />
                                    </div>
                                </div>
                            <div className="modaladdproduct__option">
                                <button><DeleteIcon style={{fontSize: '28px'}}/></button>
                            </div>
                        </div>

                    }):null
                } */}

        <button>
          <SaveIcon style={{ fontSize: "28px", color: "#FFFFFF" }} />
        </button>
      </div>
    </div>
  );
};

export const ModalAddProduct = ({ closeModal }) => {
  document.getElementsByTagName("body")[0].className = "modal-open";
  /*
    {
            "name" : "Nylon",
            "category" : "Tekstil",
            "quantity": 30,
            "new_figure" : "fire",
            "source" : "fire"
        }
    */
  const [name, setName] = useState("");
  const [components, setComponents] = useState([]);
  const [editComponents, setEditComponents] = useState([]);

  const { t } = useTranslation();

  const handleEditList = (value, index, property) => {
    setEditComponents(
      editComponents.map((editVehicle, i) => {
        if (i == index) {
          let obj = { ...editVehicle };
          obj[property] = value;
          return obj;
        }
        return editVehicle;
      })
    );
  };

  const handleResultList = (value, index, property) => {
    setComponents((prev) =>
      prev.map((vehicle, i) => {
        if (i == index) {
          let obj = { ...vehicle };
          obj[property] = value;
          return obj;
        }
        return vehicle;
      })
    );
  };

  const handleAddComponent = () => {
    setComponents([
      ...components,
      {
        name: "",
        category: "",
        quantity: 0,
        new_figure: "",
        source: "",
      },
    ]);
    setEditComponents([
      ...editComponents,
      {
        name: true,
        category: true,
        quantity: true,
        new_figure: true,
        source: true,
        expand: true,
      },
    ]);
  };
  return (
    <div className="modaladdproduct">
      <div className="modaladdproduct__modal">
        <div className="modaladdproduct__close" onClick={closeModal}>
          <CloseIcon style={{ fontSize: "34px" }} />
        </div>
        <h4>{t("PRODUCT_OR_SERVICE")}</h4>
        <div className="modaladdproduct__question">
          <h3>{t("NAME")} :</h3>
          <input type="text" className="custom__input" />
        </div>
        <h4 style={{ marginTop: "15px" }}>{t("ADD_PRODUCT_INTRO")}</h4>
        <div className="modaladdproduct__header">
          <h3>{t("COMPONENTS")}</h3>
          <RegularButton
            click={handleAddComponent}
            text={t("ADD_COMPONENTS")}
            style={2}
          />
        </div>
        {components && components.length >= 1
          ? components.map((component, i) => {
              return (
                <div className="modaladdproduct__groupoptionexpand">
                  <div className="modaladdproduct__groupoption__header">
                    {editComponents && editComponents[i].expand == false ? (
                      <ExpandMoreIcon
                        onClick={() => handleEditList(true, i, "expand")}
                      />
                    ) : (
                      <ExpandLessIcon
                        onClick={() => handleEditList(false, i, "expand")}
                      />
                    )}
                    <h4 style={{ marginLeft: "10px" }}>{component.name},</h4>
                    <h3>cat.</h3> <h4>{component.category},</h4>
                    <h3>qty.</h3> <h4>{component.quantity}</h4>{" "}
                    <h3>{t("TONNES")}.</h3>
                  </div>

                  {editComponents && editComponents[i].expand == true ? (
                    <div className="modaladdproduct__groupoption">
                      <div className="modaladdproduct__group">
                        <div className="modaladdproduct__question">
                          <h3>{t("NAME")} :</h3>
                          <EditableResultList
                            result={component.name}
                            edit={editComponents[i].name}
                            changeTo={components[i].name}
                            setValue={handleResultList}
                            indeks={i}
                            property={"name"}
                          />
                        </div>
                        <div className="modaladdproduct__question">
                          <h3>{t("CATEGORY")} :</h3>
                          <EditableResultList
                            result={component.category}
                            edit={editComponents[i].category}
                            changeTo={components[i].category}
                            setValue={handleResultList}
                            indeks={i}
                            property={"category"}
                          />
                          <h4>tonnes</h4>
                        </div>
                        <div className="modaladdproduct__question">
                          <h3>{t("QUANTITY")} :</h3>
                          <EditableResultList
                            result={component.quantity}
                            edit={editComponents[i].quantity}
                            changeTo={components[i].quantity}
                            setValue={handleResultList}
                            indeks={i}
                            property={"quantity"}
                          />
                        </div>
                        <div className="modaladdproduct__question">
                          <h3>{t("NEW_FIGURE")} :</h3>
                          <EditableResultList
                            result={component.new_figure}
                            edit={editComponents[i].new_figure}
                            changeTo={components[i].new_figure}
                            setValue={handleResultList}
                            indeks={i}
                            property={"new_figure"}
                          />
                        </div>
                        <div className="modaladdproduct__question">
                          <h3>{t("SOURCE")} :</h3>
                          <EditableResultList
                            result={component.source}
                            edit={editComponents[i].source}
                            changeTo={components[i].source}
                            setValue={handleResultList}
                            indeks={i}
                            property={"source"}
                          />
                        </div>
                      </div>
                      <div className="modaladdproduct__question">
                        <h3>{t("ESTIMATED_CARBON")} :</h3>
                        <h4>{t("TONNES")}</h4>
                      </div>
                      <div className="modaladdproduct__option">
                        <ShortButton
                          text={<DeleteIcon style={{ fontSize: "28px" }} />}
                          style={2}
                        />
                      </div>
                    </div>
                  ) : null}
                  <img
                    style={
                      editComponents && editComponents[i].expand == false
                        ? { marginTop: "10px" }
                        : null
                    }
                    src={line}
                    alt=""
                  />
                </div>
              );
            })
          : null}

        <button>
          <SaveIcon style={{ fontSize: "28px" }} />
        </button>
      </div>
    </div>
  );
};

export const AddProduct = ({ inputModal }) => {
  const { t } = useTranslation();
  return (
    <div className="addproductcomponent" onClick={inputModal}>
      <h3>{t("ADD_PRODUCT")}</h3>
      <img src={bigplus} alt="" />
    </div>
  );
};
const ProductComponent = ({
  name,
  created_at,
  thumbnail,
  detailModal,
  productId,
}) => {
  const handleDuplicateClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  return (
    <div className="productcomponent__container">
      <div className="productcomponent" style={{ position: "relative" }}>
        <DuplicateButton id={productId} onClick={handleDuplicateClick} />
        <h3>{name}</h3>

        <div className="empty__image">
          {/* <h4>Add photo here</h4> */}
          {/* <img src={thumbnail} alt="" /> */}
        </div>

        {created_at ? <h5>{created_at.split("T")[0]}</h5> : null}
      </div>
      {/* <div className="productcomponent__option">
            <img src={info} alt="" onClick={detailModal} />
            <img src={close} alt="" />
        </div> */}
    </div>
  );
};

export default ProductComponent;

export const NonCompanyComponent = ({
  name,
  created_at,
  thumbnail,
  detailModal,
}) => {
  return (
    <div className="productcomponent__container" style={{ marginTop: "15px" }}>
      <div className="productcomponent" style={{ position: "relative" }}>
        <h3>{name}</h3>

        <div className="empty__image">
          {/* <h4>Add photo here</h4> */}
          {/* <img src={thumbnail} alt="" /> */}
        </div>

        {created_at ? <h5>{created_at.split("T")[0]}</h5> : null}
      </div>
      {/* <div className="productcomponent__option">
            <img src={info} alt="" onClick={detailModal} />
            <img src={close} alt="" />
        </div> */}
    </div>
  );
};
